import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapCollection, unwrapVoid } from '../ruutsApi/normalize'
import { getPaddocks } from './getPaddocks'
import { getPaddockById } from './getPaddockById'

const savePaddocksFromKML = async ({ farm, paddocks }) => {
  if (!paddocks?.length) return []

  const paddocksToSave = paddocks.map(paddock => ({
    name: paddock.properties.name,
    farmId: farm.id,
    geometry: paddock.geometry,
    color: 'hsl(305, 63%, 25%)',
  }))

  const response = await apiClient.post(endpoints.paddocks, paddocksToSave)
  return unwrapCollection(response).map(createdPaddock => createdPaddock.id)
}

const createPaddocks = async ({ farm, years, paddocks }) => {
  if (!paddocks?.length) return []

  return Promise.all(
    years.map(async year => {
      const response = await apiClient.post(endpoints.paddocks, paddocks)
      return {
        year,
        farmId: farm.id,
        paddockIds: unwrapCollection(response).map(paddock => paddock.id),
      }
    }),
  )
}

// PUT /v1/paddocks answers `{ message }` with no payload.
const updatePaddocksFeatures = async ({ paddocks, farmId }) => {
  const paddocksToUpdate = paddocks.map(paddock => ({
    name: paddock.properties.name,
    geometry: paddock.geometry,
    farmId,
    id: paddock.properties.id,
    isInProject: paddock.properties.isInProject,
  }))

  const response = await apiClient.put(endpoints.paddocks, paddocksToUpdate)
  return unwrapVoid(response)
}

// DELETE /v1/paddocks/:id answers a raw, un-enveloped body.
const deletePaddocks = async ({ id, userRole }) => {
  const response = await apiClient.delete(`${endpoints.paddocks}/${id}`, { params: { userRole } })
  return unwrapVoid(response)
}

export const paddocks = {
  getPaddocks,
  getPaddockById,
  createPaddocks,
  updatePaddocksFeatures,
  deletePaddocks,
  savePaddocksFromKML,
}
